export default __webpack_public_path__ + "static/media/Human6.fbe87365.png";